/**
 * A small util to check if the badge is considered empty.
 *
 * @private
 */
export default function isEmpty(children, disableNullOnZero) {
    return (!disableNullOnZero &&
        (children === 0 || children === "0" || children === null));
}
//# sourceMappingURL=isEmpty.js.map